import { render } from "./Cuts.vue?vue&type=template&id=64d9e0d9&scoped=true"
import script from "./Cuts.vue?vue&type=script&lang=js"
export * from "./Cuts.vue?vue&type=script&lang=js"

import "./Cuts.vue?vue&type=style&index=0&id=64d9e0d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d9e0d9"]])

export default __exports__